module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020-desktop/0167.jpg?v=45cf7502";